import {z} from 'zod';

export const userIdParams = z.object({
  userId: z.string().min(1, 'User ID is required'),
});

export type UserIdParams = z.infer<typeof userIdParams>;
